import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const RecordingCTA = ({ onClickHandler, recordingCTA, hideCTA = false }) => {
  const theme = useTheme();
  if (hideCTA) {
    return null;
  }

  return (
    <VideoPlayerButtonComponent
      src={recordingCTA.recordingIcon}
      onClickHandler={onClickHandler}
      testID="livePlayerRecordingIcon"
      buttonContainerStyles="button-container"
      alt={recordingCTA.altHead}
      tooltipDirection="top"
      buttonClassName="live-player-recording-icon"
      $hoverBackgroundColor={theme.colours.translucentWhite}
    />
  );
};

RecordingCTA.propTypes = {
  recordingCTA: PropTypes.object,
  hideCTA: PropTypes.bool.isRequired,
  onClickHandler: PropTypes.func.isRequired,
};

export default RecordingCTA;
